import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  CalendarModule,
  DropdownModule,
  InputTextModule,
  MultiSelectModule,
  PaginatorModule,
  SelectItem,
} from 'primeng';
import { FormControl, FormGroup } from '@angular/forms';
import { VmeCommonModule } from '../../../vme-common.module';
import { ISupplierRiskManagementSearchFilterValues } from '../../../interfaces/supplier-risk-management/supplier-risk-management-search';
import { ControlsOfFlat } from '../../../utils/controls-of';
import { SupplierRiskManagementService } from '../../../services/supplier-risk-management.service';
import { RiskManagementTab } from '../../../enums/risk-management-tab.enum';
import { SupplierRiskManagementServiceType } from '../../../enums/supplier-risk-management/supplier-risk-management-service-type.enum';
import {
  CUSTOMER_PRIORITY_OPTIONS,
  SERVICE_TYPE_OPTIONS,
  SUPPLIER_CONTRACT_TYPE_OPTIONS,
  defaultServiceTypes,
} from '../risk-management-filter-options';

@Component({
  selector: 'risk-management-filters',
  standalone: true,
  imports: [
    CommonModule,
    DropdownModule,
    CalendarModule,
    InputTextModule,
    MultiSelectModule,
    PaginatorModule,
    VmeCommonModule,
  ],
  templateUrl: './risk-management-filters.component.html',
  styleUrls: ['./risk-management-filters.component.css'],
})
export class RiskManagementFiltersComponent implements OnInit {
  @Output() searchClicked: EventEmitter<ControlsOfFlat<ISupplierRiskManagementSearchFilterValues>> =
    new EventEmitter<ControlsOfFlat<ISupplierRiskManagementSearchFilterValues>>();

  filterForm: FormGroup<ControlsOfFlat<ISupplierRiskManagementSearchFilterValues>>;

  suppliers: SelectItem[] = [];
  customers: SelectItem[] = [];
  reviewStatuses: SelectItem[] = [];
  riskTypes: SelectItem[] = [];

  readonly supplierContractTypes = SUPPLIER_CONTRACT_TYPE_OPTIONS;
  readonly priorities = CUSTOMER_PRIORITY_OPTIONS;
  readonly serviceTypes = SERVICE_TYPE_OPTIONS;

  initFilters() {
    this.filterForm = new FormGroup<ControlsOfFlat<ISupplierRiskManagementSearchFilterValues>>({
      supplierIds: new FormControl<number[]>(null),
      supplierContractTypes: new FormControl<number[]>(null),
      customerIds: new FormControl<number[]>(null),
      riskTypes: new FormControl<number[]>(null),
      priorities: new FormControl<number[]>(null),
      reviewStatuses: new FormControl<number[]>(null),
      selectedTab: new FormControl<RiskManagementTab>(RiskManagementTab.AllSuppliers),
      serviceTypes: new FormControl<SupplierRiskManagementServiceType[]>(defaultServiceTypes()),
    });
  }

  get formControls() {
    return this.filterForm.controls;
  }
  constructor(private supplierRiskManagementService: SupplierRiskManagementService) {
    this.initFilters();
  }

  async ngOnInit() {
    let data = await this.supplierRiskManagementService.getFilterOptions();
    this.suppliers = data.suppliers;
    this.customers = data.customers;
    this.riskTypes = data.riskTypes;
    this.reviewStatuses = data.reviewStatuses;
  }

  protected resetClicked() {
    this.initFilters();
    this.searchClicked.emit();
  }
}
